<template>
  <focus-lock>
    <el-dialog
      ref="removeMemberDialog"
      v-loading.fullscreen.lock="mainLoader"
      aria-describedby="dialogDescription"
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="closed-account-dialog"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      title="Are you sure? This will temporarily suspend your account and make you invisible to the network. You can reactivate your account by logging in."
      :before-close="onClose"
      @opened="dialogOpen('removeMemberDialog')"
    >
      <div class="body">
        <svg-danger-exclamation />
        <h1>Remove member?</h1>
        <p>
          {{ `Are you sure you want to remove this user from ${organisation.name}? They will still appear in any chats they are a part of with other members.` }}
        </p>

        <div class="button-wrap d-flex">
          <el-button @click="onClose($event)">
            Go, back
          </el-button>
          <el-button
            type="primary"
            :loading="mainLoader"
            @click.prevent="removeMember()"
          >
            Yes, remove member
          </el-button>
        </div>
      </div>
    </el-dialog>
  </focus-lock>
</template>

<script>
import gsApi from "@/services/gs.api";
import svgDangerExclamation from "@/components/assets/svg-danger-exclamation";

export default {
  components: {
    svgDangerExclamation
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    member:{
      type:Object,
      required: true,
    },
    organisation:{
      type:Object,
      required: true,
    },
  },
  data() {
    return {
      mainLoader: false,
      dialogVisible: false
    };
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  created() {
    this.dialogVisible = this.visible;
  },

  methods: {
    onClose(e) {
      this.dialogVisible = false;
      this.$emit("close");
    },

    removeMember() {
    
      this.mainLoader = true;
      gsApi.organisation
        .removeMember(this.organisation.id, this.member.id)
        .then(() => {
          this.$emit("member-removed",this.member.id )
          this.onClose();
        })
        .catch(error => {
          this.$alert(
            "",
            `Unfortunately we're having problems contacting our service. Please try again later.`,
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            }
          );
        })
        .finally(() => {
          this.mainLoader = false;
        });
    }
  }
};
</script>
